import Display from './display';
import VectorTools from './vectorTools';
// import AudioDisplayFuzz from './audioDisplayFuzz'; // experimental!

import * as PIXI from 'pixi.js';
import { Cull } from '@pixi-essentials/cull';
import { BloomFilter } from '@pixi/filter-bloom';
import { RadialBlurFilter } from '@pixi/filter-radial-blur';
import { RGBSplitFilter } from '@pixi/filter-rgb-split';




export default class DisplayVector extends Display {


	constructor(args) {
		super(args);
		this.system = args.system;
		this.elem = args.elem;
		this.stage = null;
		this.settings = args.settings;
	}


	init() {
		let screen = this.system.screen;

		this.renderer = new PIXI.Renderer({
			resolution: screen.density,
			width: screen.canvasWidth,
			height: screen.canvasHeight,
			powerPreference: 'high-performance',
			antialias: false,
			background: 0x000000,
			autoDensity: false,
			clearBeforeRender:false,
			preserveDrawingBuffer:false
		});
		this.elem.appendChild(this.renderer.view);

		// root display container to be passed to the renderer
		this.container = new PIXI.Container();
		this.container.eventMode = 'passive';
		
		// container for Scenes
		this.stage = new PIXI.Container();
		this.container.addChild(this.stage);

		// stage background to prevent shader culling
		this.bg = new PIXI.Graphics();
		this.stage.addChild(this.bg);

		// feathered screen edge
		this.border = new PIXI.Graphics()
		this.border.eventMode = 'none';
		this.container.addChild(this.border);

		// audio interference - electron beam fuzz
		// this.fuzz = new AudioDisplayFuzz({ system:this.system });

		// trigger resize to finish
		screen.setScale();

		// viewport culling
		this.cull = new Cull({ recursive:true, toggle:'renderable' });
		this.cull.add(this.container);

		// hello
		console.log('%c [V99] Vector Entertainment System — v0.1a ', 'color:#00cc55; background:#101210; font-size:1em; padding:1em;');
	}


	initShaders(s) {
		if(s) {
			this.settings = s;
		} else {
			s = this.settings;
		}

		let screen = this.system.screen;
		let sf = this.system.screen.scaleFactor;

		// global shaders
		const color_1 = new PIXI.ColorMatrixFilter();
		if(s.saturation != 0) color_1.saturate(s.saturation, true);
		color_1.brightness(s.exposure, true);
		const aberration = new RGBSplitFilter([-s.aberration*sf,0],[s.aberration*sf,0],[0,s.aberration*sf*2*0.7683]);
		const blur = new PIXI.BlurFilter(s.beamFocus*sf, 1, screen.density, 5);
		const radial = new RadialBlurFilter(s.astigmatism, [screen.canvasWidth/2, screen.canvasHeight/2], 3, -1);
		const bloom = new BloomFilter(s.glowRadius*sf, s.glowIterations, screen.density, 5);
		const noise = new PIXI.NoiseFilter(s.noise);
		const color_2 = new PIXI.ColorMatrixFilter();
		color_2.contrast(s.contrast, false);
		const fxaa = new PIXI.FXAAFilter();
		fxaa.multisample = PIXI.MSAA_QUALITY.LOW;
		fxaa.resolution = 1;
		this.stage.filters = [
			s.antialiasing > 0 ? fxaa : false, // antialias
			color_1, // dusty phosphorous screen
			s.aberration > 0 ? aberration : false, // glass refraction
			s.beamFocus > 0 ? blur : false, // electron beam focus
			s.astigmatism > 0 ? radial : false, // electron beam astigmatism
			s.glowIterations > 0 ? bloom : false, // phosphorescence
			s.noise > 0 ? noise : false, // camera ISO noise
			color_2, // contrast
		];

		// culling
		if(s.culling == 0 && this.cull != undefined) {
			this.cull.uncull();
		}

		// border feather
		const feather = new PIXI.BlurFilter(8*sf, 3, screen.density, 5);
		this.border.filters = [ feather ];
		this.border
			.clear()
			.lineStyle(20, 0x000000, 1)
			.drawRect(0, 0, screen.width, screen.height);

		// background
		this.bg
			.clear()
			.lineStyle(0)
			.beginFill(this.system.palette.bg, 1)
			.drawRect(-200, -200, screen.width+200, screen.height+200);

		// animated filters
		this.noise = noise;

		// audio interference - electron beam fuzz
		// this.fuzz.updateSettings(s);
	}


	resize(width, height, scaleFactor) {
		super.resize(width, height, scaleFactor);
		this.renderer.resize(width, height);
		this.container.scale.set(scaleFactor);
		this.initShaders();

		requestAnimationFrame(() => {
			// wait 1 frame for new canvas to appear in DOM
			let screen = this.system.screen;
			let canvas = this.renderer.view;
			canvas.style.aspectRatio = screen.width+'/'+screen.height;
			canvas.style.width = 'auto';
			canvas.style.height = 'auto';
			canvas.style.maxWidth = '100vw';
			canvas.style.maxHeight = '100vh';
			// this.elem.style.justifyContent = 'end'; // hang right
			// this.fuzz.resize(this.renderer);
		});
	}


	render(delta, deltaNormal) {
		super.render(delta, deltaNormal);
		if(this.settings.noise > 0) this.noise.seed = 0.123 + Math.random()*0.001;
		VectorTools.get().update(delta * this.settings.lfoMult);
		if(this.settings.culling == 1) this.cull.cull(this.renderer.screen);
		this.renderer.render(this.container);
		// this.fuzz.update();
	}


	toggleFullscreen() {
		if(!document.fullscreenElement) {
			document.documentElement.requestFullscreen();
		} else if (document.exitFullscreen) {
			document.exitFullscreen();
		}
	}


	stopAudio() {
		// this.fuzz.stopAudio();
	}

	resumeAudio() {
		// this.fuzz.resumeAudio();
	}



}




